/* Lala & Mer half-yard yardage selector — global, quickbuy-safe */
(function(){
  var STEP = 0.5;
  function fmtY(y){var w=Math.floor(y),f=y-w,h=(f>=0.5)?'½':'';return ((w>0?w:'')+h)||'0';}
  function money(c){return '$'+(c/100).toFixed(2);}

  function getState(el){
    var policy=(el.dataset.policy||'').toLowerCase();
    var tracked=(el.dataset.tracked||'')!=='';
    var avail=parseInt(el.dataset.avail,10);
    return {
      unit: parseInt(el.dataset.unit,10)||0,
      vid: parseInt(el.dataset.vid,10),
      y: parseFloat(el.dataset.y||'0.5'),
      maxUnits: (tracked&&policy==='deny'&&!isNaN(avail))?avail:Infinity
    };
  }

  function render(el){
    var s=getState(el);
    var units=Math.round(s.y/STEP);
    var disp=el.querySelector('[data-lm-disp]');
    var tot=el.querySelector('[data-lm-total]');
    var cut=el.querySelector('[data-lm-cut]');
    if(disp){disp.innerHTML=fmtY(s.y);}
    if(tot){tot.textContent=money(s.unit*units);}
    if(cut){cut.innerHTML=(s.y===0.5)?' · one ½-yard cut':' · '+fmtY(s.y)+' yd ('+units+' × ½ yd)';}
  }

  function init(el){
    if(el.__lm){return;}
    el.__lm=true;
    if(!el.dataset.y){el.dataset.y='0.5';}
    var s=getState(el);
    var add=el.querySelector('[data-lm-add]');
    var note=el.querySelector('[data-lm-note]');
    var availEl=el.querySelector('[data-lm-availnote]');
    if(availEl&&s.maxUnits!==Infinity&&s.maxUnits>=1){
      availEl.hidden=false;
      var ya=s.maxUnits*STEP;
      availEl.textContent=fmtY(ya)+(ya<=1?' yard':' yards')+' available';
    }
    if(s.maxUnits<1){
      if(add){add.disabled=true;add.textContent='Out of stock';}
      if(note){note.innerHTML='<span class="lm-yard__soldout">Currently out of stock — check back soon.</span>';}
    }
    render(el);
  }

  function scan(root){
    var nodes=(root&&root.querySelectorAll)?root.querySelectorAll('[data-lm-yard]'):[];
    for(var i=0;i<nodes.length;i++){init(nodes[i]);}
  }

  document.addEventListener('click', function(ev){
    var t=ev.target;
    if(!t||!t.closest){return;}
    var stepBtn=t.closest('[data-lm-dir]');
    if(stepBtn){
      var el=stepBtn.closest('[data-lm-yard]');
      if(!el){return;}
      init(el);
      var s=getState(el);
      var n=s.y+STEP*parseFloat(stepBtn.dataset.lmDir);
      n=Math.round(n*2)/2;
      if(n<0.5){n=0.5;}
      if(s.maxUnits!==Infinity&&Math.round(n/STEP)>s.maxUnits){n=s.maxUnits*STEP;}
      el.dataset.y=n;
      render(el);
      var note=el.querySelector('[data-lm-note]');
      if(note){
        note.innerHTML=(s.maxUnits!==Infinity&&Math.round(n/STEP)>=s.maxUnits)
          ? 'That’s all we have in stock right now.'
          : 'Cut as one continuous piece';
      }
      return;
    }
    var addBtn=t.closest('[data-lm-add]');
    if(addBtn){
      var el2=addBtn.closest('[data-lm-yard]');
      if(!el2||addBtn.disabled){return;}
      init(el2);
      var s2=getState(el2);
      var q=Math.round(s2.y/STEP);
      var label=fmtY(s2.y)+(s2.y<=1?' yard':' yards');
      addBtn.disabled=true;addBtn.textContent='Adding…';
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:s2.vid,quantity:q,properties:{'Length':label}}]})
      })
      .then(function(r){if(!r.ok){throw new Error('add failed');}return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){
        addBtn.disabled=false;addBtn.textContent='Add to cart';
        var note2=el2.querySelector('[data-lm-note]');
        if(note2){note2.innerHTML='<span class="lm-yard__soldout">Sorry, couldn’t add that — please try again.</span>';}
      });
      return;
    }
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){scan(document);});
  } else {
    scan(document);
  }
  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var added=muts[i].addedNodes;
      for(var j=0;j<added.length;j++){
        var n=added[j];
        if(n.nodeType===1){
          if(n.matches&&n.matches('[data-lm-yard]')){init(n);}
          scan(n);
        }
      }
    }
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* ---- Length re-sync (added 2026-08-11) ----------------------------------
   The "Length" line-item property is written once at add-to-cart. If the
   customer changes a line's quantity in the cart/drawer afterwards, the
   property goes stale (order #15804). This module re-checks the cart after
   any cart mutation (fetch or XHR) and on page load, and rewrites Length to
   match quantity x 1/2 yd wherever it disagrees. */
(function(){
  var busy=false;
  function fmtY(y){var w=Math.floor(y),f=y-w,h=(f>=0.5)?'½':'';return ((w>0?w:'')+h)||'0';}
  function label(q){var y=q*0.5;return fmtY(y)+(y<=1?' yard':' yards');}
  function sync(){
    if(busy){return;}
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var fixes=[];
      for(var i=0;i<cart.items.length;i++){
        var it=cart.items[i];
        var p=it.properties;
        if(p&&Object.prototype.hasOwnProperty.call(p,'Length')&&p.Length!=null){
          var want=label(it.quantity);
          if(String(p.Length)!==want){fixes.push({line:i+1,quantity:it.quantity,properties:{'Length':want}});}
        }
      }
      if(!fixes.length){return;}
      busy=true;
      var chain=Promise.resolve();
      fixes.forEach(function(f){
        chain=chain.then(function(){
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(f)});
        });
      });
      chain.then(function(){busy=false;}).catch(function(){busy=false;});
    }).catch(function(){});
  }
  var CART_RE=/\/cart\/(change|update|add)(\.js)?(\?|$)/;
  var of=window.fetch;
  window.fetch=function(input){
    var url=(typeof input==='string')?input:((input&&input.url)||'');
    var res=of.apply(this,arguments);
    if(CART_RE.test(url)&&!busy&&res&&res.then){res.then(function(){setTimeout(sync,400);},function(){});}
    return res;
  };
  var oOpen=XMLHttpRequest.prototype.open,oSend=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this.__lmCartUrl=u;return oOpen.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(){
    var x=this;
    if(CART_RE.test(String(x.__lmCartUrl||''))){
      x.addEventListener('load',function(){if(!busy){setTimeout(sync,400);}});
    }
    return oSend.apply(this,arguments);
  };
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sync);}else{sync();}
})();
